export default {
  index:'Home',
  groupInfo:{
    title:'Our Company',
    recommend:{
      name:'Company Profile',
      desc:''
    },
    history:{
      name:'Development History',
      desc:''
    },
    culture:{
      name:'Corporate Culture',
      desc:''
    },
    honor:{
      name:'Company Honors',
      desc:''
    },
  },
  spread:{
    title:'Our Business',
    goods:{
      name:'Sourcing and delivery of virtual goods',
      desc:''
    },
    advert:{
      name:'Promotion and advertising services',
      desc:''
    },
    game:{
      name:'Mobile games and software development and maintenance services',
      desc:''
    },
    lottery:{
      name:' Solutions on lottery-related software systems and equipment',
      desc:''
    },
  },
  marketing:{
    title:'Marketing Service Platform',
    platform_0:{
      name:' Rego Virtual Goods Platform',
      desc:''
    },
    platform_1:{
      name:'Advertising Marketing Platform',
      desc:''
    },
    platform_2:{
      name:'SaaS Enterprise Marketing Service Platform',
      desc:''
    },
  },
  investor:{
    title:'Investor Relations',
    noContent:'No content',
    details:'details',
    back:'back',
    loading:'loading',
    notice:{
      name:'Announcement',
      desc:'',
      files:{
        flie0:'Formal Notice',
        flie1:'Articles of Association',
        flie2:'Accountants\' Report and Report on Unaudited Pro Forma Financial Information',
        flie3:'Audited Consolidated Financial Statements',
        flie4:'Harneys letter in relation to summary of certain aspects of the Cayman Companies Act',
        flie5:'the Cayman Companies Act',
        flie6:'PRC legal opinions',
        flie7:'Industry Report',
        flie8:'Service Contracts and letters of Appointment',
        flie9:'Material Contracts',
        flie10:'Consents of Experts',
        flie11:'Articles of Association',
        flie12:'Terms of Reference of the Audit Committee',
        flie13:'Terms of Reference of the Remuneration Committee',
        flie14:'Terms of Reference of the Nomination Committee',
        flie15:'List of Directors and their Roles and Functions',
        flie16:'Procedures for Shareholders to Nominate Candidates for Directors',
        flie17:'Shareholders Communication Policy',
      }
    },
    file:{
      name:'Prospectus',
      desc:'',
      files:{
        flie0:'GLOBAL OFFERING',
        flie1:'APPLICATION FORM',
        flie2:'Announcement of Offer Price and Allotment Results',
      }
    },
    report:{
      name:'Financial reports',
      desc:'',
      files:{
        flie0:'Monthly Returns - Monthly Return of Equity Issuer on Movements in Securities for the Month Ended 31 October 2022',
      }
    },
    news:{
      name:'News',
      desc:''
    },
    telephone:{
      name:'IR Contact',
      desc:'',
      address:'2/F, Building 8  Yinhu Innovation Centre, Yinhu Street Fuyang District Hangzhou'
    },
  },
  aboutUs:{
    title:'About us',
    contact:{
      name:'Join us',
      desc:''
    },
    join:{
      name:'Talents Wanted ',
      desc:''
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js